<template>
    <div class="modal" :class="{'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Create Invoice</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <custom-invoice-client-select v-if="!details"></custom-invoice-client-select>
                <custom-invoice-details-select v-if="user && !details"></custom-invoice-details-select>
                <custom-invoice-body v-if="user && details"></custom-invoice-body>
            </section>
            <footer class="modal-card-foot">
                <button class="button"  @click="closeModal">Close</button>
                <button class="button is-primary" v-if="buttonsEnabled && !hasNoInvoice" @click="createCustomInvoice">Save</button>
                <button class="button" v-if="buttonsEnabled && !hasNoInvoice" @click="downloadPDF">
                    <span class="icon is-small">
                      <i class="fas fa-file-pdf"></i>
                    </span>
                    <span>Output (PDF)</span>
                </button>
                <button class="button" v-if="buttonsEnabled && !hasNoInvoice" @click="downloadEXCEL">
                    <span class="icon is-small">
                      <i class="fas fa-file-excel"></i>
                    </span>
                    <span>Output (EXCEL)</span>
                </button>
                <button class="button" v-if="buttonsEnabled && !hasNoInvoice" disabled>Last updated @ {{ invoiceUpdateDate }}</button>
                <button class="button is-danger" v-if="buttonsEnabled && !hasNoInvoice">DELETE</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import CustomInvoiceBody from './CustomInvoiceBody'
    import CustomInvoiceSelectTypeAndDetails from './CustomInvoiceSelectTypeAndDetails'
    import CustomInvoiceClientSelect from './CustomInvoiceClientSelect'
    import CustomInvoiceDetailsSelect from './CustomInvoiceDetailsSelect'
    export default {
        components: {
            CustomInvoiceBody,
            CustomInvoiceSelectTypeAndDetails,
            CustomInvoiceClientSelect,
            CustomInvoiceDetailsSelect
        },
        methods: {
            closeModal() {
                this.$store.dispatch('changeCustomInvoiceModalStatus', { status: false, invoice_id: null })
                this.$store.dispatch('changeCustomInvoiceToDefault')
                this.$store.dispatch('changeCustomInvoiceQueryToDefault')

            },
            downloadPDF() {
                this.$store.dispatch('downloadCustomInvoicePdf')
            },
            downloadEXCEL() {
                this.$store.dispatch('downloadCustomInvoiceExcel')
            },
            saveCustomInvoice() {
                this.$store.dispatch('saveCustomInvoice')
            },
            createCustomInvoice() {
                this.$store.dispatch('createCustomInvoice')
            }
        },
        computed: {
            user() {
                return this.$store.getters.getCustomInvoice.user_id
            },
            details() {
                return this.$store.getters.getCustomInvoice.invoice_details_id
            },
            number() {
                  return this.$store.getters.getCustomInvoice.id
            },
            isActive() {
                return this.$store.getters.getCustomInvoiceModalStatus
            },
            haveNoPortOfLoading() {
                return this.car.port_of_loading === null
            },
            buttonsEnabled() {
                return !this.$store.getters.getCustomInvoiceErrorStatus
            },
            invoiceUpdateDate() {
                return this.$store.getters.getCustomInvoice.updated_at
            },
            errorStatus() {
                return this.$store.getters.getCustomInvoiceErrorStatus
            },
            errorMessage() {
                return this.$store.getters.getCustomInvoiceErrorMessage
            },
            hasNoInvoice() {
                return this.$store.getters.getActiveModalCustomInvoiceId
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 90%;
        height: 100%;
    }
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    td {
        font-size: large;
    }
    .is-static {
        min-width: 50px;
    }
    th {
        font-size: small;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceModal.vue